import React from 'react';

import * as Sentry from '@sentry/react';
import isNil from 'lodash/isNil';

const IS_PREMIUM_AND_SERVER =
  !plugin.isFree && plugin.runtimeEnvironment === 'server';

export const splitToNewLines = (message) => {
  if (isNil(message)) {
    return null;
  }

  return message
    .toString()
    .split('\n')
    .map((line, index) => {
      return (
        <span key={index}>
          {line}
          <br />
        </span>
      );
    });
};

export const sendErrorReport = (error, message, errorDetails) => {
  if (IS_PREMIUM_AND_SERVER) {
    Sentry.init({
      dsn: plugin.sentryDsn,
      environment: plugin.environment,
      release: plugin.version,
    });
  }

  let errObject = error;

  if (!(errObject instanceof Error)) {
    errObject = new Error(message);
    errObject.name = errorDetails.text;
    errObject.message = message;
  }

  Sentry.withScope((scope) => {
    scope.setTag('errorType', 'userSubmittedErrorReport');
    scope.setTag('platform', plugin.runtimeEnvironment);
    scope.setExtra('errorMessage', errorDetails.text);
    scope.setExtra('message', message);
    scope.setLevel('fatal');

    Sentry.captureException(errObject);
  });
};
